module.exports = __webpack_public_path__ + "static/stu.3a974947.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/quote_assets/stu.png
// module id = 1113
// module chunks = 35783957827783